import styled from 'styled-components'

import theme from '~/theme'

import { IProcessingImageFeedbackProps } from './types'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
`

export const Status = styled.p`
  font-size: 12px;
  text-align: center;
  margin: ${theme.tokens.spacingUnit * 3}px 0 ${theme.tokens.spacingUnit * 2}px;
`

export const Disclaimer = styled.p`
  font-size: 9px;
  text-align: center;
  margin-top: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  bottom: ${theme.tokens.spacingUnit * 8}px;

  svg {
    margin-right: ${theme.tokens.spacingUnit * 1.5}px;
  }
`

export const ProgressContainer = styled.div`
  display: block;
  width: 200px;
  border-radius: ${theme.tokens.spacingUnit}px;
  height: ${theme.tokens.spacingUnit}px;
  background-color: ${({ theme }) => theme.colors.neutral.black200};
`

export const ProgressBar = styled.span<Pick<IProcessingImageFeedbackProps, 'complete' | 'started'>>`
  display: block;
  transition: all ease 0.5s;
  width: ${props => (props.complete ? '100%' : props.started ? '10%' : '0%')};
  height: ${theme.tokens.spacingUnit}px;
  border-radius: ${theme.tokens.spacingUnit}px;
  background-color: ${({ theme }) => theme.colors.palette.black};
`
